import actions from './action';

const {
  GET_REVIEWRATING_BEGIN,
  GET_REVIEWRATING_SUCCESS,
  GET_REVIEWRATING_FAILED,
  ADD_REVIEWRATING_BEGIN,
  ADD_REVIEWRATING_SUCCESS,
  ADD_REVIEWRATING_FAILED,
  DELETE_REVIEWRATING_BEGIN,
  DELETE_REVIEWRATING_SUCCESS,
  DELETE_REVIEWRATING_FAILED,
  UPDATE_REVIEWRATING_BEGIN,
  UPDATE_REVIEWRATING_SUCCESS,
  UPDATE_REVIEWRATING_FAILED,
} = actions;

const initState = {
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  reviewratings: [],
  loading: false,
  error: null,
};

const REVIEWRATINGReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_REVIEWRATING_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_REVIEWRATING_SUCCESS:
      return {
        ...state,
        total: data.total,
        reviewratings: data.reviewAndRating,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: false,
      };
    case GET_REVIEWRATING_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_REVIEWRATING_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_REVIEWRATING_SUCCESS:
      return {
        ...state,
        reviewratings: [data, ...state.reviewratings],
        total: state.total + 1,
        loading: false,
      };
    case ADD_REVIEWRATING_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_REVIEWRATING_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_REVIEWRATING_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        reviewratings: data,
        loading: false,
      };
    case DELETE_REVIEWRATING_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_REVIEWRATING_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_REVIEWRATING_SUCCESS:
      return {
        ...state,
        reviews: data,
        loading: false,
      };
    case UPDATE_REVIEWRATING_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default REVIEWRATINGReducer;
